export const GroundMapper = [
    {
        title:'ground zero',
        subtitle:'The home ground for all of it.',
        linkTo:'/play',
    },
    {
        title:'react-form-hook',
        subtitle:'A hook that can be used for advanced level of tracking, validating forms and realtime text-typing-watching. [practice]',
        linkTo:'/play/react-form-hook',
    },
    {
        title:'Reset password: form-hook',
        subtitle:'Reset password module with all validations using react-form-hook:A hook that can be used for advanced level of tracking, validating forms and realtime text-typing-watching. [practice]',
        linkTo:'/play/react-form-hook/reset-password-form',
    },
    {
        title:'JS: Console Methods and Usage',
        subtitle:'A list of console methods and their proper/advanced usage. [practice]',
        linkTo:'/play/js-console-methods-and-usage',
    },
    {
        title:'Lodash: Array methods',
        subtitle:'Getting started with Lodash-array methods with some advanced features. [practice, blog, info]',
        linkTo:'/play/lodash-array-methods',
    },
]